/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Button, getPayloadObject, getTelemetryAttributes, ITelemetryContent, TelemetryConstant } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { observer } from 'mobx-react';
import * as React from 'react';

export interface INavIconProps {
    mobileHamburgerAriaLabel: string;
    isExpanded: boolean;
    targetId: string;
    telemetryContent?: ITelemetryContent;
    toggleNavBar(): void;
}

/**
 *
 * NavIcon component
 * @extends {React.PureComponent<INavIconProps>}
 */

@observer
export class NavIcon extends React.Component<INavIconProps> {

    private attributes?: Msdyn365.IDictionary<string>;

    constructor(props: INavIconProps) {
        super(props);
        const payLoad = getPayloadObject('click', props.telemetryContent!, TelemetryConstant.NavIcon);
        this.attributes = getTelemetryAttributes(props.telemetryContent!, payLoad);
    }

    public render():JSX.Element {
        return (
            <Button
                className='ms-header__nav-icon'
                onClick={this.props.toggleNavBar}
                title={this.props.mobileHamburgerAriaLabel}
                aria-label={this.props.mobileHamburgerAriaLabel}
                aria-expanded={this.props.isExpanded}
                aria-controls={this.props.targetId}
                {...this.attributes}
            />
        );
    }
}